module.exports = __webpack_public_path__ + "static/media/tutorialsicon.90e9d1c5.svg";